import TextInputEx from "components/_extensions/react-admin/input/TextInputEx";
import { DateTimeInput, NumberInputEx } from "components/inputs";
import { YesNoInput } from "components/inputs";
import { FieldType } from "entities/FieldType";
import React from "react";
import { TextInput } from "react-admin";

export const CustomFieldInput = ({ fieldType, isFilter, ...props }) => {
	switch (fieldType) {
		case FieldType.integer:
			return <NumberInputEx {...props} />;
		case FieldType.float:
			return <NumberInputEx type="float" digitsCount={2} step={100} {...props} />;
		case FieldType.string:
			return <TextInputEx {...props} />;
		case FieldType.bool:
			return <YesNoInput {...props} />;
		case FieldType.datetime:
			return <DateTimeInput {...props} withLocalTimeZone={isFilter} />;
		default:
			return isFilter ? null : <TextInput {...props} />;
	}
};
